<!--
  global-top-nav
  ─────────────────────────────────────────────────────────────────────────────
  Unified top navigation shell. All child components are reused as-is;
  this shell is purely a layout/positioning container.
-->
@if (navStateConfig$ | async; as navState) {
  <nav
    #topNavRoot
    class="global-top-nav"
    [ngClass]="[
      'global-top-nav__mode-' + navState.breakpointMode,
      (seasonalClass$ | async) || '',
      navState.search.isSearchActivated === true
        ? 'global-top-nav--search-active'
        : navState.search.isSearchActivated === false
          ? 'global-top-nav--search-inactive'
          : 'global-top-nav--search-fixed',
    ]"
    [attr.data-layout]="navState.breakpointMode"
    aria-label="Top navigation"
  >
    <!-- ── LEFT REGION ──────────────────────────────────────────────────── -->
    <div class="global-top-nav__left">
      @if (navState.topNav.showBurger) {
        <nv-icon-button
          class="global-top-nav__burger-btn"
          isInverted="true"
          name="hamburger-large-white"
          [ariaLabelData]="{
            iconButtonAriaLabel: navState.sideNav.matIsSideNavOpened ? 'Close menu' : 'Open menu',
          }"
          (clickButton)="onBurgerClick()"
        ></nv-icon-button>
      }
      @if (navState.topNav.showLogo) {
        <nv-logo
          class="global-top-nav__logo-btn"
          type="portal-all-white"
          [pointerOnHover]="true"
          (logoClick)="onLogoClick()"
        >
        </nv-logo>
      }
      @if (navState.topNav.showEntitySelector) {
        <div class="global-top-nav__entity-selector">
          <global-entity-selector></global-entity-selector>
        </div>
      }
    </div>
    <!-- /LEFT REGION -->

    <!-- ── CENTER REGION ────────────────────────────────────────────────── -->
    <div class="global-top-nav__center">
      @if (navState.topNav.showSearch) {
        <div class="global-top-nav__search">
          <global-search-adapter></global-search-adapter>
        </div>
      }
    </div>
    <!-- /CENTER REGION -->

    <!-- ── RIGHT REGION ─────────────────────────────────────────────────── -->
    <div class="global-top-nav__right">
      @if (navState.topNav.showActions) {
        @if (!isNoteRestricted) {
          <nv-icon-button
            isInverted="true"
            class="global-top-nav__action-icon"
            name="note-add-large-white"
            [ariaLabelData]="{ iconButtonAriaLabel: 'Create note' }"
            (clickButton)="onAddNote()"
          ></nv-icon-button>
        }
      }
      @if (navState.topNav.showProfileIcon) {
        <user-profile-icon-navigation></user-profile-icon-navigation>
      }
    </div>
    <!-- /RIGHT REGION -->
  </nav>
}
